/*
 * This file is part of the https://gitlab-intern.easd-support.de/easd/p26s26_energie_watchdog project.
 *
 * (c) 2026 EA Systems Dresden GmbH
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

export const electricityPriceTranslations = {
    de: {
        'A recommendation will appear as soon as current price data is available.': 'Eine Empfehlung erscheint, sobald aktuelle Preisdaten verfügbar sind.',
        'Avoid': 'Vermeiden',
        'Avoid consumption if possible': 'Verbrauch möglichst vermeiden',
        'Battery storage': 'Batteriespeicher',
        'Best available price': 'Bester verfügbarer Preis',
        'Best consumption time': 'Bester Verbrauchszeitpunkt',
        'Can be scheduled later': 'Zeitlich verschiebbar',
        'Can start up to {hours} hours later': 'kann bis zu {hours} Stunden später starten',
        'Commercial fleet charging': 'Laden der Fahrzeugflotte',
        'Compressed-air system': 'Druckluftanlage',
        'Consider': 'Abwägen',
        'Consider waiting': 'Ggf. abwarten',
        'Consider current needs': 'Aktuellen Bedarf abwägen',
        'Consume': 'Verbrauchen',
        'Consume electricity': 'Strom verbrauchen',
        'Consume electricity soon': 'Strom bald verbrauchen',
        'Current price': 'Aktueller Preis',
        'Day-ahead prices may still change. All information is provided without guarantee.': 'Die Preise sind Day-Ahead-Preise und können sich noch ändern. Alle Angaben ohne Gewähr.',
        'Dishwasher': 'Geschirrspüler',
        'Dryer': 'Trockner',
        'Electric car': 'Elektroauto',
        'Electricity is expected to be cheaper {time}.': 'Der Strom ist voraussichtlich {time} günstiger.',
        'Electricity is expected to be significantly cheaper {time}.': 'Der Strom ist voraussichtlich {time} deutlich günstiger.',
        'Electricity price recommendation': 'Strompreis-Empfehlung',
        'Expected price': 'Erwarteter Preis',
        'Falling': 'Sinkend',
        'Favourable soon': 'Bald günstig',
        'Flexible consumption': 'Flexibler Verbrauch',
        'Flexible consumption next day': 'Flexibler Verbrauch am nächsten Tag',
        'Flexible industrial consumption': 'Flexibler Industrieverbrauch',
        'Flexible industrial consumption next day': 'Flexibler Industrieverbrauch am nächsten Tag',
        'From {time}': 'ab {time} Uhr',
        'Green – good time for flexible consumption': 'Grün – guter Zeitpunkt für flexiblen Verbrauch',
        'In {hours} hours': 'In {hours} Stunden',
        'In {hours}:{minutes} hours': 'in {hours}:{minutes} Stunden',
        'In {minutes} minutes': 'in {minutes} Minuten',
        'In one minute': 'in einer Minute',
        'Industrial battery storage': 'Gewerblicher Batteriespeicher',
        'Industrial process heat': 'Industrielle Prozesswärme',
        'Industry': 'Industrie',
        'Keep waiting': 'Abwarten',
        'No relevant savings are expected from waiting within the selected period.': 'Innerhalb des gewählten Zeitraums ist durch Warten keine relevante Einsparung zu erwarten.',
        'Not yet optimal': 'Noch nicht optimal',
        'Now is a good time': 'Jetzt ist ein guter Zeitpunkt',
        'One minute ago': 'vor einer Minute',
        'Optional waiting: Electricity is expected to be cheaper {time}.': 'Optional warten: Der Strom ist voraussichtlich {time} noch günstiger.',
        'Potential savings': 'Mögliche Ersparnis',
        'Price data is currently available for {available} of {requested} requested hours.': 'Preisdaten sind aktuell für {available} der angefragten {requested} Stunden verfügbar.',
        'Price outlook': 'Preisausblick',
        'Prices and recommendations over time (for the next {hours} hours)': 'Preise und Empfehlungen im Zeitverlauf (für die nächsten {hours} Stunden)',
        'Prices are rising. The current slot is more attractive than the following hours.': 'Die Preise steigen. Der aktuelle Zeitraum ist attraktiver als die folgenden Stunden.',
        'Private': 'Privat',
        'Production process': 'Produktionsprozess',
        'Recommendation for the current time (for the next {hours} hours)': 'Empfehlung für den aktuellen Zeitpunkt (für die nächsten {hours} Stunden)',
        'Red – wait if possible': 'Rot – wenn möglich warten',
        'Refrigeration and cold storage': 'Kälteanlage / Kühlhaus',
        'Rising': 'Steigend',
        'Stable': 'Stabil',
        'The current price is expensive. Avoid flexible consumption if possible.': 'Der aktuelle Preis ist teuer. Flexiblen Verbrauch nach Möglichkeit vermeiden.',
        'The current price is favourable and no relevant additional savings are expected.': 'Der aktuelle Preis ist günstig und es ist keine relevante zusätzliche Einsparung zu erwarten.',
        'The current slot is the best available option within the selected period.': 'Der aktuelle Zeitraum ist die beste verfügbare Option innerhalb des gewählten Zeitraums.',
        'Trend': 'Tendenz',
        'Trend (next {hours} hours)': 'Tendenz (nächste {hours} Stunden)',
        'Unfavourable': 'Ungünstig',
        'Updated: {date} at {time}': 'Aktualisiert: {date} um {time} Uhr',
        'Updated: Not available': 'Aktualisiert: Nicht verfügbar',
        'Use soon': 'Bald nutzen',
        'Use soon if needed': 'Bei Bedarf zeitnah nutzen',
        'Wait': 'Warten',
        'Wait if possible': 'Wenn möglich warten',
        'Waiting is worthwhile': 'Warten lohnt sich',
        'Water heating': 'Warmwasserbereitung',
        'Washing machine': 'Waschmaschine',
        'Yellow – weigh up current needs': 'Gelb – aktuellen Bedarf abwägen',
        'hour': 'Stunde',
        'within {hours} hours': 'innerhalb von {hours} Stunden',
        'up to {hours} hours': 'bis zu {hours} Stunden',
        'What would you like to use?': 'Was möchten Sie nutzen?',
        '{minutes} minutes ago': 'vor {minutes} Minuten',
    },
    en: {
        'A recommendation will appear as soon as current price data is available.': 'A recommendation will appear as soon as current price data is available.',
        'Avoid': 'Avoid',
        'Avoid consumption if possible': 'Avoid consumption if possible',
        'Battery storage': 'Battery storage',
        'Best available price': 'Best available price',
        'Best consumption time': 'Best consumption time',
        'Can be scheduled later': 'Can be scheduled later',
        'Can start up to {hours} hours later': 'can start up to {hours} hours later',
        'Commercial fleet charging': 'Commercial fleet charging',
        'Compressed-air system': 'Compressed-air system',
        'Consider': 'Consider',
        'Consider waiting': 'Consider waiting',
        'Consider current needs': 'Consider current needs',
        'Consume': 'Consume',
        'Consume electricity': 'Consume electricity',
        'Consume electricity soon': 'Consume electricity soon',
        'Current price': 'Current price',
        'Day-ahead prices may still change. All information is provided without guarantee.': 'Prices are day-ahead prices and may still change. All information is provided without guarantee.',
        'Dishwasher': 'Dishwasher',
        'Dryer': 'Dryer',
        'Electric car': 'Electric car',
        'Electricity is expected to be cheaper {time}.': 'Electricity is expected to be cheaper {time}.',
        'Electricity is expected to be significantly cheaper {time}.': 'Electricity is expected to be significantly cheaper {time}.',
        'Electricity price recommendation': 'Electricity price recommendation',
        'Expected price': 'Expected price',
        'Falling': 'Falling',
        'Favourable soon': 'Favourable soon',
        'Flexible consumption': 'Flexible consumption',
        'Flexible consumption next day': 'Flexible consumption next day',
        'Flexible industrial consumption': 'Flexible industrial consumption',
        'Flexible industrial consumption next day': 'Flexible industrial consumption next day',
        'From {time}': 'from {time}',
        'Green – good time for flexible consumption': 'Green – good time for flexible consumption',
        'In {hours} hours': 'In {hours} hours',
        'In {hours}:{minutes} hours': 'in {hours} h {minutes} min',
        'In {minutes} minutes': 'in {minutes} minutes',
        'In one minute': 'in one minute',
        'Industrial battery storage': 'Industrial battery storage',
        'Industrial process heat': 'Industrial process heat',
        'Industry': 'Industry',
        'Keep waiting': 'Keep waiting',
        'No relevant savings are expected from waiting within the selected period.': 'No relevant savings are expected from waiting within the selected period.',
        'Not yet optimal': 'Not yet optimal',
        'Now is a good time': 'Now is a good time',
        'One minute ago': 'one minute ago',
        'Optional waiting: Electricity is expected to be cheaper {time}.': 'Optional waiting: Electricity is expected to be cheaper {time}.',
        'Potential savings': 'Potential savings',
        'Price data is currently available for {available} of {requested} requested hours.': 'Price data is currently available for {available} of {requested} requested hours.',
        'Price outlook': 'Price outlook',
        'Prices and recommendations over time (for the next {hours} hours)': 'Prices and recommendations over time (for the next {hours} hours)',
        'Prices are rising. The current slot is more attractive than the following hours.': 'Prices are rising. The current slot is more attractive than the following hours.',
        'Private': 'Private',
        'Production process': 'Production process',
        'Recommendation for the current time (for the next {hours} hours)': 'Recommendation for the current time (for the next {hours} hours)',
        'Red – wait if possible': 'Red – wait if possible',
        'Refrigeration and cold storage': 'Refrigeration and cold storage',
        'Rising': 'Rising',
        'Stable': 'Stable',
        'The current price is expensive. Avoid flexible consumption if possible.': 'The current price is expensive. Avoid flexible consumption if possible.',
        'The current price is favourable and no relevant additional savings are expected.': 'The current price is favourable and no relevant additional savings are expected.',
        'The current slot is the best available option within the selected period.': 'The current slot is the best available option within the selected period.',
        'Trend': 'Trend',
        'Trend (next {hours} hours)': 'Trend (next {hours} hours)',
        'Unfavourable': 'Unfavourable',
        'Updated: {date} at {time}': 'Updated: {date} at {time}',
        'Updated: Not available': 'Updated: Not available',
        'Use soon': 'Use soon',
        'Use soon if needed': 'Use soon if needed',
        'Wait': 'Wait',
        'Wait if possible': 'Wait if possible',
        'Waiting is worthwhile': 'Waiting is worthwhile',
        'Water heating': 'Water heating',
        'Washing machine': 'Washing machine',
        'Yellow – weigh up current needs': 'Yellow – weigh up current needs',
        'hour': 'hour',
        'within {hours} hours': 'within {hours} hours',
        'up to {hours} hours': 'up to {hours} hours',
        'What would you like to use?': 'What would you like to use?',
        '{minutes} minutes ago': '{minutes} minutes ago',
    },
    es: {
        'A recommendation will appear as soon as current price data is available.': 'La recomendación aparecerá en cuanto haya datos de precios actuales disponibles.',
        'Avoid': 'Evitar',
        'Avoid consumption if possible': 'Evitar el consumo si es posible',
        'Battery storage': 'Almacenamiento en batería',
        'Best available price': 'Mejor precio disponible',
        'Best consumption time': 'Mejor momento de consumo',
        'Can be scheduled later': 'Se puede programar más tarde',
        'Can start up to {hours} hours later': 'puede empezar hasta {hours} horas más tarde',
        'Commercial fleet charging': 'Carga de la flota de vehículos',
        'Compressed-air system': 'Sistema de aire comprimido',
        'Consider': 'Valorar',
        'Consider waiting': 'Considerar esperar',
        'Consider current needs': 'Valorar la necesidad actual',
        'Consume': 'Consumir',
        'Consume electricity': 'Consumir electricidad',
        'Consume electricity soon': 'Consumir electricidad pronto',
        'Current price': 'Precio actual',
        'Day-ahead prices may still change. All information is provided without guarantee.': 'Los precios son precios del mercado diario y aún pueden cambiar. Toda la información se proporciona sin garantía.',
        'Dishwasher': 'Lavavajillas',
        'Dryer': 'Secadora',
        'Electric car': 'Coche eléctrico',
        'Electricity is expected to be cheaper {time}.': 'Se espera que la electricidad sea más barata {time}.',
        'Electricity is expected to be significantly cheaper {time}.': 'Se espera que la electricidad sea considerablemente más barata {time}.',
        'Electricity price recommendation': 'Recomendación del precio de la electricidad',
        'Expected price': 'Precio esperado',
        'Falling': 'Bajando',
        'Favourable soon': 'Pronto será favorable',
        'Flexible consumption': 'Consumo flexible',
        'Flexible consumption next day': 'Consumo flexible al día siguiente',
        'Flexible industrial consumption': 'Consumo industrial flexible',
        'Flexible industrial consumption next day': 'Consumo industrial flexible al día siguiente',
        'From {time}': 'a partir de las {time}',
        'Green – good time for flexible consumption': 'Verde – buen momento para el consumo flexible',
        'In {hours} hours': 'Dentro de {hours} horas',
        'In {hours}:{minutes} hours': 'en {hours} h {minutes} min',
        'In {minutes} minutes': 'en {minutes} minutos',
        'In one minute': 'en un minuto',
        'Industrial battery storage': 'Almacenamiento industrial en batería',
        'Industrial process heat': 'Calor de proceso industrial',
        'Industry': 'Industria',
        'Keep waiting': 'Seguir esperando',
        'No relevant savings are expected from waiting within the selected period.': 'No se espera un ahorro relevante por esperar dentro del periodo seleccionado.',
        'Not yet optimal': 'Aún no es óptimo',
        'Now is a good time': 'Ahora es un buen momento',
        'One minute ago': 'hace un minuto',
        'Optional waiting: Electricity is expected to be cheaper {time}.': 'Opcionalmente, espere: se espera que la electricidad sea aún más barata {time}.',
        'Potential savings': 'Ahorro posible',
        'Price data is currently available for {available} of {requested} requested hours.': 'Actualmente hay datos de precios disponibles para {available} de las {requested} horas solicitadas.',
        'Price outlook': 'Previsión de precios',
        'Prices and recommendations over time (for the next {hours} hours)': 'Precios y recomendaciones a lo largo del tiempo (durante las próximas {hours} horas)',
        'Prices are rising. The current slot is more attractive than the following hours.': 'Los precios están subiendo. El periodo actual es más atractivo que las horas siguientes.',
        'Private': 'Privado',
        'Production process': 'Proceso de producción',
        'Recommendation for the current time (for the next {hours} hours)': 'Recomendación para el momento actual (durante las próximas {hours} horas)',
        'Red – wait if possible': 'Rojo – esperar si es posible',
        'Refrigeration and cold storage': 'Refrigeración y almacenamiento frigorífico',
        'Rising': 'Subiendo',
        'Stable': 'Estable',
        'The current price is expensive. Avoid flexible consumption if possible.': 'El precio actual es caro. Evite el consumo flexible si es posible.',
        'The current price is favourable and no relevant additional savings are expected.': 'El precio actual es favorable y no se espera ningún ahorro adicional relevante.',
        'The current slot is the best available option within the selected period.': 'El periodo actual es la mejor opción disponible dentro del intervalo seleccionado.',
        'Trend': 'Tendencia',
        'Trend (next {hours} hours)': 'Tendencia (próximas {hours} horas)',
        'Unfavourable': 'Desfavorable',
        'Updated: {date} at {time}': 'Actualizado: {date} a las {time}',
        'Updated: Not available': 'Actualizado: No disponible',
        'Use soon': 'Usar pronto',
        'Use soon if needed': 'Usar pronto si es necesario',
        'Wait': 'Esperar',
        'Wait if possible': 'Esperar si es posible',
        'Waiting is worthwhile': 'Vale la pena esperar',
        'Water heating': 'Preparación de agua caliente',
        'Washing machine': 'Lavadora',
        'Yellow – weigh up current needs': 'Amarillo – valorar la necesidad actual',
        'hour': 'hora',
        'within {hours} hours': 'en un plazo de {hours} horas',
        'up to {hours} hours': 'hasta {hours} horas',
        'What would you like to use?': '¿Qué desea utilizar?',
        '{minutes} minutes ago': 'hace {minutes} minutos',
    },
} as const;
